import React from "react";
import BuyPackage from "../../../components/LKWallet/BuyPackage/buypackage.component";

export default class BuyPackageScreen extends React.Component {
  render() {
    return <BuyPackage />;
  }
}
